module.exports = __webpack_public_path__ + "static/media/packet.2e209799.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/packet.svg
// module id = 131
// module chunks = 0